import { recurringEditScopes } from '@/generated/backend';
import type { RecurringEditScope } from '@/types/enums';

export function recurrenceScopeLabel(value: RecurringEditScope): string {
  return recurringEditScopes.find((scope) => scope.value === value)?.label ?? value;
}
